import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconBrand } from '@uhg-abyss/web/ui/IconBrand';
import { useOnboarding } from '@sde/widgets-core/src/redux/resources/onboarding';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { TrainingTips } from 'src/common/TrainingTips';
import { OnboardingTour } from './OnboardingTour';
import { useHeaderMenu } from 'src/state/headerMenu';

const StyledDashboardIcon = styled(IconBrand, {
  position: 'absolute',
  margin: '0 auto',
  top: -50,
  padding: 10,
  left: 0,
  right: 0,
  backgroundColor: '$white',
  borderRadius: '70px',
});

const StyledModalHeader = styled('h3', {
  fontSize: 24,
  lineHeight: '28px',
  textAlign: 'center',
  paddingTop: '20px',
  marginBottom: '20px',
  color: '$primary1',
});

const StyledModalText = styled('p', {
  margin: '15px 25px 10px 25px',
  lineHeight: '20px',
  textAlign: 'justify',
});

export const DashboardTooltipModal = ({ uuid, isUnitTest }) => {
  const { user } = useUser.state();
  const { isProviderOpen, isPayerOpen } = useHeaderMenu.state();
  const { getOnboarding, setOnboarding } = useOnboarding.actions();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showTutorial, setShowTutorial] = useState(false);

  useEffect(() => {
    let timeout;

    if (uuid) {
      timeout = setTimeout(() => {
        getOnboarding(uuid, (response) => {
          setIsModalOpen(response.intros.dashboard);
        });
      }, 2000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [uuid]);

  const setSkipTour = () => {
    setIsModalOpen(false);
    if (!user.isTechnicalUser) {
      setOnboarding({ uuid, intros: { dashboard: false } });
    }
  };

  const setTutorial = () => {
    setShowTutorial(true);
    setSkipTour();
  };

  const tutorials = [
    {
      id: 'dashboard-tutorial',
      name: 'Dashboard Tutorial',
      component: OnboardingTour,
    },
  ];
  return (
    <React.Fragment>
      <TrainingTips tutorials={tutorials} appKey="dashboard" user={user} />
      <If condition={showTutorial}>
        <OnboardingTour isActive />
      </If>
      <Modal
        isOpen={(isModalOpen && !isProviderOpen && !isPayerOpen) || isUnitTest}
        hideClose={true}
        size={600}
      >
        <StyledDashboardIcon icon="desktop" size={90} />
        <Modal.Section>
          <StyledModalHeader>
            <b>
              Welcome to your new
              <br />
              portal home page.
            </b>
          </StyledModalHeader>
          <StyledModalText>
            We're excited to introduce our redesigned, customizable site. The
            redesign allows you to customize this page to your needs and the
            tasks you typically complete in the portal. And, it features easier
            navigation and streamlined search tools. You may retrigger these
            tips anytime by clicking on your name in the top right corner and
            select Reactivate Training Tips. Let us show you around.
          </StyledModalText>
          <Layout.Stack alignLayout="center">
            <Button onClick={setTutorial}>Next</Button>
            <Link onClick={setSkipTour} data-testid="skip-the-tour">
              End Tour
            </Link>
          </Layout.Stack>
        </Modal.Section>
      </Modal>
    </React.Fragment>
  );
};

DashboardTooltipModal.propTypes = {
  uuid: PropTypes.string,
  isUnitTest: PropTypes.bool,
};

DashboardTooltipModal.defaultProps = {
  uuid: null,
  isUnitTest: false,
};
